import './styles.css'
import React from 'react'
import { Form, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'


function KegCollectionPickupInstructions(props) {
  const { onChange, formValues, isDisabled } = props
  const { t: translate } = useTranslation()

  return (
    <>
      <Form.TextArea
        id="kc_ce_pickupInstructionsTextarea"
        value={formValues.pickupInstruction}
        onChange={(_, data) => onChange(String(data.value))}
        rows={4}
        placeholder={translate('pickupInstructionsPlaceholder')}
        disabled={isDisabled}
        maxLength={150}
      />
      <div style={{ textAlign: 'right' }}>
        <Label basic size="small">
          {formValues.pickupInstruction.length}/150
        </Label>
      </div>
    </>
  )
}

export default React.memo(KegCollectionPickupInstructions)
